import { configResponsive, useResponsive } from 'ahooks'

configResponsive({
  xs: 0,
  sm: 501,
  md: 768,
  lg: 881,
  xl: 1201,
})
export const useLayoutSize = () => {
  const responsive = useResponsive()
  return { isMobileSize: !responsive['sm'], isLeftMiddleSize: !responsive['xl'] }
}
